import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DatosService } from '../services/datos.service';
import { AuthService } from 'src/data/services/auth/auth.service';
import { UsuarioAuthDataService } from '../services/usuario-auth-data.service';

export const adminAccessGuard: CanActivateFn = () => {
  const datos = inject(DatosService);
  const router = inject(Router);
  const usuarioAuthDataService = inject(UsuarioAuthDataService);
  const user = usuarioAuthDataService.usuarioAuth();

  if (!user) return router.parseUrl('/login');
  const role = String(user.rol?.nombre ?? '').toUpperCase().trim();
  if (role !== 'ROLE_ADMIN') return router.parseUrl('/category');

  return true; // ✅ deja pasar a admin
};
